export default {
    '1': 'Falsches Produkt bestellt',
    '2': 'Doppelte Bestellung',
    '3': 'Annahme nicht möglich',
    '4': 'Sonstige Gründe',
    '充值金额不能小于1': 'Formatfehler: Aufladebetrag darf nicht kleiner als 1 sein (zwei Dezimalstellen)',
    '-连接已建立-': '-Verbindung hergestellt-',
    ',才可提币': ', um abheben zu können',
    '[code]值错误': '[code] Wert fehlerhaft',
    '[symbol]参数为空': '[symbol] Parameter ist leer',
    homeDownloadtips41: 'Händler-App',
    '不能为空': 'Darf nicht leer sein',
    '不在交易时段': 'Außerhalb der Handelszeiten',
    '不在可提现时间内': 'Außerhalb der Auszahlungszeit',
    '参数错误': 'Parameterfehler',
    '参数异常，消息获取失败': 'Parameterfehler, Nachricht konnte nicht abgerufen werden',
    '操作成功': 'Vorgang erfolgreich',
    '操作类型不能小于0': 'Vorgangstyp darf nicht kleiner als 0 sein',
    '操作类型不是整数': 'Vorgangstyp ist keine ganze Zahl',
    '操作类型为空': 'Vorgangstyp ist leer',
    '产品不存在': 'Produkt existiert nicht',
    '产品剩余数量不足': 'Verbleibende Produktmenge unzureichend',
    '承兑商不存在': 'Händler existiert nicht',
    '程序错误': 'Programmfehler',
    '持有币种不足': 'Unzureichender Währungsbestand',
    '充值价值不得大于最大限额': 'Aufladewert darf das Höchstlimit nicht überschreiten',
    '充值价值不得小于最小限额': 'Aufladewert darf das Mindestlimit nicht unterschreiten',
    '充值链错误': 'Aufladekette fehlerhaft',
    '充值数量不能小于等于0': 'Aufladebetrag darf nicht kleiner oder gleich 0 sein',
    '存在不同杠杆的持仓单': 'Es bestehen Positionen mit unterschiedlichem Hebel',
    '存在重复的角色名称': 'Doppelter Rollenname vorhanden',
    '大于最大采购数量': 'Größer als die maximale Bestellmenge',
    '代理层级错误': 'Fehlerhafte Agentenebene',
    '待付款的订单无法放行': 'Unbezahlte Bestellung kann nicht freigegeben werden',
    '当前地址格式错误': 'Aktuelles Adressformat fehlerhaft',
    '当前订单不为待付款状态，无法取消': 'Bestellung ist nicht im Status „Zahlung ausstehend“ und kann nicht storniert werden',
    '当前还需交易': 'Aktuell noch Handel erforderlich',
    '当日才可申购': 'Zeichnung nur am selben Tag möglich',
    '当日可提现次数不足': 'Anzahl der heutigen Auszahlungen unzureichend',
    '登陆密码不符合设定': 'Anmeldepasswort entspricht nicht den Vorgaben',
    '登陆密码长度不符合设定': 'Länge des Anmeldepassworts entspricht nicht den Vorgaben',
    '登录过期，请重新登录': 'Sitzung abgelaufen, bitte erneut anmelden',
    '登录密码必须6-12位': 'Anmeldepasswort muss 6-12 Zeichen lang sein',
    '登录密码不能为空': 'Anmeldepasswort darf nicht leer sein',
    '登录失败': 'Anmeldung fehlgeschlagen',
    '电话号码已绑定': 'Telefonnummer bereits verknüpft',
    '电话号码已绑定其他用户': 'Telefonnummer ist bereits mit einem anderen Nutzer verknüpft',
    '订单不存在': 'Bestellung existiert nicht',
    '订单已取消': 'Bestellung storniert',
    '订单已取消，无法放行': 'Bestellung storniert, Freigabe nicht möglich',
    '订单已完成，无法放行': 'Bestellung abgeschlossen, Freigabe nicht möglich',
    '发现新版本，请升级到最新版本': 'Neue Version verfügbar, bitte auf die neueste Version aktualisieren',
    '服务器错误': 'Serverfehler',
    '服务器错误(500)': 'Serverfehler (500)',
    '该产品未上架': 'Dieses Produkt ist nicht gelistet',
    '该产品已上市，无法购买': 'Dieses Produkt ist bereits gelistet, Kauf nicht möglich',
    '该订单已取消': 'Diese Bestellung wurde storniert',
    '该广告剩余数量不足': 'Verbleibende Menge dieser Anzeige unzureichend',
    '该基金尚未开放购买': 'Dieser Fonds ist noch nicht zum Kauf freigegeben',
    '该基金尚已封闭': 'Dieser Fonds ist bereits geschlossen',
    '该邮箱已被订阅': 'Diese E-Mail wurde bereits abonniert',
    '格式有误:充值金额不能小于1(包含俩位小数)': 'Formatfehler: Aufladebetrag darf nicht kleiner als 1 sein (zwei Dezimalstellen)',
    '跟单倍数输入错误': 'Falsche Eingabe des Copy-Trading-Multiplikators',
    '跟单参数输入错误': 'Falsche Eingabe der Copy-Trading-Parameter',
    '更新提醒': 'Update-Hinweis',
    '工作地址不能为空': 'Arbeitsadresse darf nicht leer sein',
    '购买矿机时间不得低于托管订单剩余时间': 'Die Mietdauer der Mining-Maschine darf nicht kürzer als die Restlaufzeit der Hosting-Bestellung sein',
    '广告不存在': 'Anzeige existiert nicht',
    '广告已下架': 'Anzeige wurde entfernt',
    '基金剩余购买金额不足': 'Verbleibender Kaufbetrag des Fonds unzureichend',
    '家庭地址不能为空': 'Privatadresse darf nicht leer sein',
    '交易员不存在': 'Trader existiert nicht',
    '交易员不能跟随自己': 'Trader kann sich nicht selbst folgen',
    '交易员跟随人数已满': 'Maximale Followerzahl des Traders erreicht',
    '交易员未开启带单': 'Trader hat Copy-Trading nicht aktiviert',
    '交易员无法跟随另一个交易员': 'Ein Trader kann keinem anderen Trader folgen',
    '角色被用户关联，不可删除': 'Rolle ist mit Nutzern verknüpft und kann nicht gelöscht werden',
    '角色不存在': 'Rolle existiert nicht',
    '金额不在购买区间': 'Betrag liegt nicht im Kaufbereich',
    '金额错误': 'Betragsfehler',
    '旧密码不能为空': 'Altes Passwort darf nicht leer sein',
    '旧密码不正确': 'Altes Passwort ist falsch',
    '可平仓合约张数不足': 'Unzureichende Anzahl schließbarer Kontrakte',
    '矿机不存在': 'Mining-Maschine existiert nicht',
    '矿机未解锁，无法购买': 'Mining-Maschine nicht freigeschaltet, Kauf nicht möglich',
    '历史基金无法购买': 'Historischer Fonds kann nicht gekauft werden',
    '连续输入错误三次，请3分钟后再试': 'Dreimal hintereinander falsch eingegeben, bitte in 3 Minuten erneut versuchen',
    '领取成功': 'Erfolgreich erhalten',
    '买入金额需要在区间内': 'Kaufbetrag muss im Bereich liegen',
    '卖方无法取消该订单': 'Der Verkäufer kann diese Bestellung nicht stornieren',
    '没有找到用户': 'Kein Nutzer gefunden',
    verificationCode: 'Bestätigungscode',
    pleaseEnterVerificationCode: 'Bitte Bestätigungscode eingeben',
    pleaseEnterUsername: 'Bitte Benutzernamen eingeben',
    username: 'Benutzername',
    getVerificationCode: 'Code anfordern',
    tryAgainLater: 'Sekunden bis zum erneuten Versuch',
    '密码必须6-12位': 'Passwort muss 6-12 Zeichen lang sein',
    '密码不能为空': 'Passwort darf nicht leer sein',
    '密码不正确': 'Passwort ist falsch',
    '您当前可分配额度不足': 'Ihr aktuell zuweisbares Limit ist unzureichend',
    '您没有符合条件的收款方式': 'Sie haben keine geeignete Zahlungsmethode',
    '您已存在订单': 'Sie haben bereits eine Bestellung',
    '您已购买过体验矿机,不得重复购买': 'Sie haben bereits eine Test-Mining-Maschine gekauft und können nicht erneut kaufen',
    '亲属地址不能为空': 'Adresse des Angehörigen darf nicht leer sein',
    '亲属电话不能为空': 'Telefon des Angehörigen darf nicht leer sein',
    '亲属关系不能为空': 'Verwandtschaftsverhältnis darf nicht leer sein',
    '亲属姓名不能为空': 'Name des Angehörigen darf nicht leer sein',
    '请检查网络连接': 'Bitte Netzwerkverbindung prüfen',
    '请切换其他语言后查看': 'Bitte in einer anderen Sprache ansehen',
    '请上传图片': 'Bitte ein Bild hochladen',
    '请稍后再试': 'Bitte später erneut versuchen',
    '请稍后重试': 'Bitte später erneut versuchen',
    '请输入充值币种': 'Bitte Aufladewährung eingeben',
    '请输入内容': 'Bitte Inhalt eingeben',
    '请输入搜索关键字': 'Bitte Suchbegriff eingeben',
    '请输入正确的货币数量': 'Bitte eine gültige Währungsmenge eingeben',
    '请输入正确的金额': 'Bitte einen gültigen Betrag eingeben',
    '请输入正确的数量': 'Bitte eine gültige Menge eingeben',
    '请输入正确的质押金额': 'Bitte einen gültigen Staking-Betrag eingeben',
    '请输入正确的质押天数': 'Bitte eine gültige Staking-Dauer (Tage) eingeben',
    '请填写正确的电话号码': 'Bitte eine gültige Telefonnummer eingeben',
    '请填写正确的验证码': 'Bitte einen gültigen Bestätigungscode eingeben',
    '请填写正确的邮箱地址': 'Bitte eine gültige E-Mail-Adresse eingeben',
    '请先绑定谷歌验证器': 'Bitte zuerst Google Authenticator verknüpfen',
    '请先添加收款方式': 'Bitte zuerst eine Zahlungsmethode hinzufügen',
    '请先通过高级认证': 'Bitte zuerst die erweiterte Verifizierung abschließen',
    '请选择买卖方式': 'Bitte Kauf-/Verkaufsart wählen',
    '请选择正确的币种': 'Bitte eine gültige Währung wählen',
    '请重新登录': 'Bitte erneut anmelden',
    '渠道未开通': 'Kanal nicht aktiviert',
    '取消': 'Abbrechen',
    '确认': 'Bestätigen',
    '申购数量错误': 'Falsche Zeichnungsmenge',
    '申请成功': 'Antrag erfolgreich',
    '身份证已实名过!': 'Ausweis wurde bereits verifiziert!',
    '审核已通过': 'Prüfung bestanden',
    '审核中': 'In Prüfung',
    '实名认证未通过，无法进行高级认证': 'Identitätsprüfung nicht bestanden, erweiterte Verifizierung nicht möglich',
    '收款方输入错误': 'Falsche Eingabe des Zahlungsempfängers',
    '授权状态未成功': 'Autorisierungsstatus nicht erfolgreich',
    '赎回状态异常': 'Rücknahmestatus fehlerhaft',
    '所选汇率不存在': 'Gewählter Wechselkurs existiert nicht',
    '提币数量不能小于等于0': 'Auszahlungsbetrag darf nicht kleiner oder gleich 0 sein',
    '提交失败': 'Übermittlung fehlgeschlagen',
    '提交失败，当前有未处理订单': 'Übermittlung fehlgeschlagen, es bestehen offene Bestellungen',
    '提示': 'Hinweis',
    '提现不得大于限额': 'Auszahlung darf das Limit nicht überschreiten',
    '提现不得小于限额': 'Auszahlung darf das Limit nicht unterschreiten',
    '图片不得大于10M': 'Bild darf nicht größer als 10 MB sein',
    '图片不得大于2M': 'Bild darf nicht größer als 2 MB sein',
    '图片大小不能超过2M！': 'Bildgröße darf 2 MB nicht überschreiten!',
    '图片上传失败': 'Bild-Upload fehlgeschlagen',
    '推荐码不正确': 'Empfehlungscode ist falsch',
    '推荐人无权限推荐': 'Der Empfehler ist nicht berechtigt zu empfehlen',
    '推荐商品': 'Empfohlene Produkte',
    '委托数量(张)必填': 'Auftragsmenge (Kontrakte) ist erforderlich',
    '委托数量(张)不能小于等于0': 'Auftragsmenge (Kontrakte) darf nicht kleiner oder gleich 0 sein',
    '未绑定谷歌验证器': 'Google Authenticator nicht verknüpft',
    '未绑定手机号': 'Keine Telefonnummer verknüpft',
    '未绑定邮箱': 'Keine E-Mail verknüpft',
    '未发现授权记录': 'Kein Autorisierungseintrag gefunden',
    '未实名认证，是否认证？': 'Nicht verifiziert. Jetzt verifizieren?',
    '未授权访问': 'Nicht autorisierter Zugriff',
    '未找到符合条件的匹配订单': 'Keine passende Bestellung gefunden',
    '未找到匹配的收益记录': 'Kein passender Ertragseintrag gefunden',
    myComment: 'Meine Bewertungen',
    myPoint: 'Meine Punkte',
    accountInfo: 'Kontoinformationen',
    myBalance: 'Mein Guthaben',
    myCoupon: 'Meine Gutscheine',
    unused: 'Nicht verwendet',
    used: 'Verwendet',
    expired: 'Abgelaufen',
    expires: 'Gültig bis',
    minSpend: 'Ab',
    availableBalance: 'Verfügbares Guthaben',
    personalDeposit: 'Guthaben',
    useDepositBalance: 'Guthaben zur Verrechnung verwenden',
    depositDeduct: 'Guthabenabzug',
    useMaxDeposit: 'Voller Abzug',
    balanceHistory: 'Guthabenverlauf',
    recordCount: 'Insgesamt {count} Einträge',
    depositType: 'Transaktionstyp',
    balanceAfter: 'Restguthaben',
    depositTypeRecharge: 'Guthabenaufladung',
    depositTypeAdjustment: 'Guthabenanpassung',
    depositTypeOrderPayment: 'Bestellzahlung',
    depositTypeOrderRefunds: 'Bestellerstattung',
    depositTypeDistributionCommission: 'Vertriebsprovision',
    depositTypeDistributionWithdrawal: 'Vertriebsauszahlung',
    depositTypeOther: 'Sonstige',
    income: 'Einnahmen',
    expense: 'Ausgaben',
    description: 'Beschreibung',
    myFootprint: 'Mein Verlauf',
    '我的购物车': 'Mein Warenkorb',
    '无权限': 'Keine Berechtigung',
    '无效的UID': 'Ungültige UID',
    '系统参数错误': 'Systemparameterfehler',
    '系统存在相同[系统登录名]！': 'Im System existiert bereits derselbe [Anmeldename]!',
    '系统错误，请稍后重试': 'Systemfehler, bitte später erneut versuchen',
    '下单不能小于最小金额限制': 'Bestellung darf den Mindestbetrag nicht unterschreiten',
    '校验IP不合法': 'Ungültige Prüf-IP',
    '新密码不能为空': 'Neues Passwort darf nicht leer sein',
    '新密码不一致': 'Neue Passwörter stimmen nicht überein',
    '新密码确认不能为空': 'Bestätigung des neuen Passworts darf nicht leer sein',
    '行情获取异常，稍后再试': 'Kursdaten konnten nicht abgerufen werden, bitte später erneut versuchen',
    '验证类型不能为空': 'Verifizierungstyp darf nicht leer sein',
    '验证码不能为空': 'Bestätigungscode darf nicht leer sein',
    '验证码不正确': 'Bestätigungscode ist falsch',
    '验证码错误': 'Bestätigungscode fehlerhaft',
    '页码不能小于等于0': 'Seitenzahl darf nicht kleiner oder gleich 0 sein',
    '页码不是整数': 'Seitenzahl ist keine ganze Zahl',
    '已领取': 'Bereits erhalten',
    '用户不存在': 'Nutzer existiert nicht',
    '用户名必须由数字和英文字母组成': 'Benutzername darf nur aus Zahlen und lateinischen Buchstaben bestehen',
    '用户名不存在': 'Benutzername existiert nicht',
    '用户名不符合设定': 'Benutzername entspricht nicht den Anforderungen',
    '用户名不能为空': 'Benutzername darf nicht leer sein',
    '用户名参数为空': 'Benutzername-Parameter ist leer',
    '用户名重复': 'Benutzername bereits vergeben',
    '用户剩余数量不足': 'Verbleibende Nutzermenge unzureichend',
    '用户已跟随交易员': 'Nutzer folgt dem Trader bereits',
    '邮箱已绑定': 'E-Mail bereits verknüpft',
    '邮箱已绑定其他用户': 'E-Mail ist bereits mit einem anderen Nutzer verknüpft',
    '余额不足': 'Unzureichendes Guthaben',
    shop_order_insufficientBalance: 'Kontoguthaben unzureichend',
    '帐户异常需要进行C3认证，请联系在线客服。': 'Kontoauffälligkeit, C3-Verifizierung erforderlich. Bitte den Online-Kundendienst kontaktieren.',
    '找不到用户': 'Nutzer nicht gefunden',
    flashSale: 'Flash-Sale',
    groupBuy: 'Gruppenkauf',
    groupBuying: 'Sammelbestellung',
    couponCenter: 'Gutschein-Center',
    pointMall: 'Punkte-Shop',
    liveList: 'Livestream',
    endsIn: 'Endet in',
    soldOut: 'Verkauft',
    people: 'Personen',
    joined: 'Beigetreten',
    startGroup: 'Gruppenkauf starten',
    getCoupon: 'Einlösen',
    '直线关系，不能修改推荐': 'Direkte Beziehung, Empfehlung kann nicht geändert werden',
    '重复提交': 'Mehrfache Übermittlung',
    '转账币种不能为空': 'Überweisungswährung darf nicht leer sein',
    '转账数量不能小于等于0': 'Überweisungsbetrag darf nicht kleiner oder gleich 0 sein',
    '状态不能小于0': 'Status darf nicht kleiner als 0 sein',
    '状态不是整数': 'Status ist keine ganze Zahl',
    '资金密码必须6-12位': 'Fondspasswort muss 6-12 Zeichen lang sein',
    '资金密码不符合设定': 'Fondspasswort entspricht nicht den Anforderungen',
    '资金密码不能为空': 'Fondspasswort darf nicht leer sein',
    '资金密码错误': 'Fondspasswort fehlerhaft',
    '资金密码长度不符合设定': 'Länge des Fondspassworts entspricht nicht den Anforderungen',
    'UID不能为空': 'UID darf nicht leer sein',
    required: 'Dieses Feld ist erforderlich',
    nickname: 'Spitzname',
    enterNickname: 'Bitte Spitznamen eingeben',
    gender: 'Geschlecht',
    male: 'Männlich',
    female: 'Weiblich',
    secret: 'Geheim',
    birthday: 'Geburtstag',
    selectDate: 'Datum auswählen',
  cancelOrderMap: {
    0: "Ich will es nicht.",
    1: "Habe das Produkt verlegt",
    2: "Doppelte Bestellung",
    3: "Empfang fehlgeschlagen",
    4: "Andere Gründe",
  },
  "获取验证码": "Erhält Zahl",
  "请输入验证码": "Bitte geben Sie die Zahl ein",
  "发送": "Senden",
  "验证码": "Code",
  "已发送，请注意查收": "Gesendet, bitte beachten Sie die Abholung",
  "加值": "Wert hinzufügen",
  "银行卡": "Bankkarte",
  "平台人工发起退款": "Plattforminitiierte Rückerstattung",
  "联系商家": "Kontaktieren Sie den Händler",
  "提领": "Abheben",
  "电商批发商场": "E-Commerce-Großhandelsmarkt",
  "请输入完整的支付密码!" : "Bitte geben Sie das vollständige Zahlungspasswort ein!",
  "用户未发表评论": "Benutzer hat nicht kommentiert",
  "订单": "Befehl",
  "下单成功，等待付款": "Bestellung erfolgreich aufgegeben, wartet auf Zahlung",
  "下单成功，付款成功": "Bestellung erfolgreich aufgegeben, Zahlung erfolgreich",
  "已发货，正在运输中": "Versendet, im Transport",
  "订单已取消，原因:手动发起取消订单": "Die Bestellung wurde storniert. Grund: Bestellung manuell stornieren.",
  "订单已取消，原因:超时自动取消订单": "Bestellung wurde storniert. Grund: Die Bestellung wird bei Zeitüberschreitung automatisch storniert.",
  "商家已确认，已进入备货状态": "Der Händler wurde bestätigt und ist in den Bestandsstatus eingetreten.",
  "长时间未付款，系统自动取消订单": "Bei Nichtzahlung über einen längeren Zeitraum wird die Bestellung automatisch storniert.",
  "系统发货成功": "Systembereitstellung erfolgreich",
  "订单已签收": "Bestellung erhalten",
  "发起退款申请": "Starten Sie eine Rückerstattungsanfrage",
  "退款成功": "Rückerstattung erfolgreich",
  "退款失败": "Rückerstattung fehlgeschlagen",
  "订单退款成功": "Rückerstattung der Bestellung erfolgreich",
  "订单退款失败": "Rückerstattung der Bestellung fehlgeschlagen",
  "系统默认好评": "Das System verwendet standardmäßig positive Bewertungen",
  "请输入关键字搜索": "Bitte geben Sie ein Stichwort zur Suche ein",
  "猜你喜欢": "Denke es gefällt dir",
  "订单已完成": "Die Bestellung ist abgeschlossen",
  "热销推荐": "Heiße Verkaufsempfehlung",
  "头像选择": "Avatar-Auswahl",
  "修改头像": "Ändern Sie Ihren Avatar",
  subOrder: "Bestellung abschicken",
  "mailboxCheck": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  "switchLang": "Bitte wechseln Sie zur Anzeige in eine andere Sprache",
  "myCart": "Mein Einkaufswagen",
  "notQua": "Die Qualifikationsbedingungen sind nicht erfüllt.",
  "noSmaller": "Die aufgebrachte Menge darf nicht kleiner sein als",
  "nomax": "Die maximale Antragsmenge darf nicht überschritten werden",
  "evaluationUploading": "Sie müssen noch Bilder hochladen. Bitte versuchen Sie es später erneut",
  "evaluateInput": "Rückblick mit Bildern",
  "moneyOrderStatus": "Bestellstatus",
  "coinBlock": "Währungsabkommen",
  "dealing": "In Bearbeitung",
  "dealSuccess": "Erfolgreich",
  "dealFail": "Scheitern",
  "payCertificate": "Zahlungszertifikat",
  "handleFee": "Servicegebühr",
  "highOpinion": "Gute Rückmeldungen",
  "mediumOpinion": "Mittlere Bewertung",
  "lowOpinion": "Schlechte Bewertungen",
  "hasImage": "Mit Bildern",
  "rechargeMethod": "Auflademodus",
  "scanAndDown": "QR-Code scannen APP herunterladen",
  "receivedAddress": "Empfangsadresse",
  "ActualLedger": "Tatsächliche Quittung",
  "view": "Sicht",
  "withdrawNum": "Bargeldabhebungsmenge",
  "rechargeNum": "Menge aufladen",
  "date": "Datum",
  "walletHistory": "Brieftaschenverlauf",
  "accountBalance": "Kontostand",
  "accountReview": "Kontoübersicht",
  "rated": "Überprüft",
  "receiver": "Empfänger",
  "orderStatus": "Status",
  "orderTime": "Zeit",
  "tax": "Besteuerung",
  "discount": "Rabatt",
  "productInfo": "Produktinformation",
  "paramError": "Parameterfehler",
  "orderInfo": "Bestellinformationen",
  "rebuy": "Noch eine Bestellung",
  "pleaseCorrectAddress": "Bitte geben Sie die korrekte Bargeldabhebungsadresse ein",
  "pleaseInputCorrectNumber": "Bitte geben Sie eine Zahl größer als 0 ein",
  "vcodePass": "Überprüfung bestanden!",
  "vcodeFail": "Authentifizierung fehlgeschlagen. Bitte erneut versuchen",
  "uploading": "Hochladen...",
  "uploadSuccess": "Hochgeladen erfolgreich",
  "uploadError": "Upload fehlgeschlagen. Bitte versuche es erneut",
  "registerSuccess": "Registrierung erfolgreich",
  "pleaseSetMobileNumber": "Bitte geben Sie die Telefonnummer ein",
  "unSelectedProduct": "Sie haben kein Produkt ausgewählt",
  "loginSuccess": "Anmeldung erfolgreich",
  "pleaseSetAreaCode": "Geben Sie den Ländernamen und die Ortsvorwahl ein, um zu suchen",
  "login": "Anmeldung",
  "register": "Anmeldung",
  "logout": "Ausfahrt",
  "noData": "Keine Daten gefunden",
  "search": "Suchen",
  "historySearch": "Historische Suche",
  "empty": "Leer",
  "home": "Startseite",
  "favorableRate": "Rate guter Bewertungen",
  "classification": "Kategorie",
  "searchTips": "Quellensuche/Produkt/Lieferant/Bestellung",
  "dailyNewArrival": "Täglich neue Produkte aufgelistet",
  "more": "Mehr",
  "recommend": "Empfehlung",
  "recommendedProducts": "Empfohlene Produkte",
  "recommendedStore": "Empfehlenswerte Geschäfte",
  "buyNow": "Jetzt kaufen",
  "addCart": "In den Warenkorb legen",
  "complex": "Integriert",
  "price": "Preis",
  "retailPrice": "Endverbraucherpreis",
  "originPrice": "Original Preis",
  "service": "Kundendienst",
  "collect": "Favoriten",
  "sold": "Verkaufsvolumen",
  "pageviews": "Umfang des Surfens",
  "quantity": "Menge",
  "freight": "Ladung",
  "shipping": "Versand",
  "ship": "Boot",
  "buyTips": "Versand innerhalb von 24 Stunden nach Auftragserteilung. Die folgenden Bestellungen unterliegen der logistischen Kontrolle und werden möglicherweise verspätet versendet. Bitte beachten Sie die Logistikinformationen oder wenden Sie sich an den Kundendienst.",
  "totalPrice": "Gesamtpreis",
  "addCartMessage": "Erfolgreich zum Warenkorb hinzugefügt",
  "addCartMessageFaild": "Das Produkt ist bereits im Warenkorb vorhanden.",
  "myAccount": "Mein Konto",
  "buyHistory": "Aufzeichnungen kaufen",
  "wishlist": "Lieblingsprodukte",
  "trackOrder": "Befehl",
  "account": "Konto:",
  "sellerZone": "Händlerbereich",
  "beSeller": "Kaufmann werden",
  "sellerPanelLogin": "Händler-Login",
  "footTip": "© Urheberrecht {name} Ltd 2024",
  "footTips": "{name} Limited ist von der Financial Conduct Authority als Kreditvermittler (713206) autorisiert und reguliert und handelt ausschließlich mit dem Kreditgeber Home Retail Group CardServices Limited als {name} Financial Services. {name} Financial Services ist von der Financial Conduct Authority zur Bereitstellung von Krediten autorisiert und reguliert (716148). Home Retail GroupCard Services Limited ist im Vereinigten Königreich (04007072) in Avebury, 489-499 Avebury Boulevard, Milton Keynes, Vereinigtes Königreich, registriert. MK9 2NW.",
  "item": "Artikel",
  "checkout": "Eine Bestellung aufgeben",
  "productDescription": "Produktbeschreibung",
  "userEvaluation": "Benutzerbewertungen",
  "AllProducts": "Alle Produkte",
  "followers": "Folgen",
  "sales": "Verkaufsvolumen",
  "visitStore": "Besuchen Sie den Laden",
  "authentic": "100% echt",
  "dayReturns7": "7 Tage Rückgaberecht",
  "shippingDiscounts": "Frachtrabatt",
  "safePayment": "Sichere Bezahlung",
  "followed": "Gefolgt",
  "dashboard": "Instrumententafel",
  "myOrder": "Meine Bestellung",
  "setUp": "Aufstellen",
  "successTips": "Erfolgreich",
  "copySuccess": "Replikation erfolgreich",
  "balance": "Guthaben (USDT)",
  "sort": "Typ",
  "commodity": "Produkt",
  "browse": "Verkaufsvolumen",
  "recharge": "Aufladen",
  "commodityCollection": "Produktsammlung",
  "withdraw": "Bargeldabhebung",
  "defaultAddress": "Standardadresse",
  "addNewAddress": "Neue Adresse hinzufügen",
  "withdrawRecord": "Bargeldabhebungsaufzeichnung",
  "serialNumber": "Best.-Nr.",
  "time": "Zeit",
  "amount": "Menge",
  "processing": "In Bearbeitung",
  "fail": "Scheitern",
  "blockchainNetwork": "Blockchain-Netzwerk",
  "records": "Aufzeichnen",
  "withdrawAddress": "Adresse für Bargeldabhebungen",
  "withdrawInputTips": "Bitte geben Sie die Auszahlungsadresse ein",
  "copy": "Reproduzieren",
  "enterTips": "Bitte eingeben",
  "actualAccount": "Tatsächliches Konto",
  "handlingFee": "Servicegebühr",
  "confirm": "Empfang bestätigen",
  "previous": "Vorheriger Schritt",
  "pleaseEnterAddress": "Bitte geben Sie die Adresse ein",
  "pleaseEnterQuantity": "Bitte Menge eingeben",
  "withdrawSuccess": "Bestellungen erfolgreich übermittelt",
  "saveQr": "QR-Code speichern",
  "pleaseEnterAmount": "Bitte geben Sie den Aufladebetrag ein",
  "expectedArrival": "Erwartete Ankunft",
  "currentRate": "Aktueller Wechselkurs",
  "uploadTips": "Zahlungsnachweis (Screenshot der Zahlungsdetails hochladen)",
  "clickUpload": "Zum Hochladen klicken",
  "uploadPhoto": "Bitte laden Sie Fotos hoch",
  "rechargeSuccessful": "Aufladen erfolgreich",
  "rechargeTips": "Aufladeaufforderung: „Bitte geben Sie den tatsächlichen Überweisungsbetrag wahrheitsgemäß ein. Andernfalls kann das System die Genehmigung nicht bestehen und den Aufladevorgang beeinträchtigen.",
  "rechargeRecord": "Rekord aufladen",
  "all": "Alle",
  "pending": "Bezahlt werden",
  "cancelled": "Abgesagt",
  "delivered": "Verschifft werden",
  "confirmed": "Bestätigt",
  "receipt": "Empfangen werden",
  "harvested": "Erhalten",
  "comment": "Überprüft werden",
  "refund": "Rückerstattung/After-Sales",
  "cancelOrder": "Bestellung stornieren",
  "cancelReason": "Grund der Stornierung",
  "cancelOrderTitle": "Bitte wählen Sie einen Grund für die Auftragsstornierung aus",
  "returnOrderTitle": "Bitte wählen Sie den Rücksendegrund aus",
  "refundInstructions": "Anweisungen zur Rückerstattung",
  "returnDetailTips": "Bitte geben Sie eine Bewertung zum Produkt ab",
  "cancel": "Bestellung stornieren",
  "cancelOrder1": "Produkt nicht erhalten",
  "cancelOrder2": "Mag es nicht, will es nicht",
  "cancelOrder3": "Der Verkäufer hat die falsche Ware geliefert",
  "cancelOrder4": "Gefälschte Marke",
  "cancelOrder5": "Weniger Sendung, verpasste Sendung",
  "cancelOrder6": "Produkt beschädigt erhalten",
  "cancelOrder7": "Es liegt ein Qualitätsproblem vor",
  "cancelOrder8": "Verhandeln Sie die Rückerstattung mit dem Händler",
  "cancelOrder9": "Andere Gründe",
  "cancelOrderSuccess": "Bestellung erfolgreich storniert",
  "returnOrderSuccess": "Erfolgreich einreichen",
  "orderName": "Name",
  "orderEmail": "Email",
  "orderAddress": "Adresse",
  "orderNation": "Land",
  "orderState": "Status",
  "orderCity": "Stadt",
  "orderPostCode": "Postleitzahl",
  "orderAmount": "Menge",
  "orderPrefix": "Gesamtbestellung",
  "orderFee": "Steuern",
  "orderSpecification": "Spezifikation",
  "orderCommodity": "Produkt",
  "orderQuantity": "Menge",
  "orderUnitprice": "Einzelpreis",
  "orderFreight": "Ladung",
  "orderTax": "Steuer",
  "orderTotal": "Gesamt",
  "PaymentOrder": "Zahlungsauftrag",
  "Evaluate": "Rezension",
  "CancelOrder": "Bestellung stornieren",
  "RemindShip": "Erinnern Sie sich an den Versand",
  "Refund": "Erstattung",
  "Submitareview": "Bewertungen abgeben",
  "Information": "Information",
  "wrongPassword": "Passwortfehler mehr als 3 Mal. Bitte versuchen Sie es morgen erneut.",
  "Operate": "Betrieb",
  "Item": "Artikel)",
  "From": "Aus",
  "hint": "Tipps",
  "CheckDetails": "Einzelheiten anzeigen",
  "Payment": "Zahlung",
  "Cancel": "Stornieren",
  "refundSuccessfully": "Rückerstattung erfolgreich",
  "pendingPayment": "Bezahlt werden",
  "pay": "Zahlung",
  "LoginPassword": "Passwort",
  "sure": "Natürlich",
  "shippingAddress": "Empfangsadresse",
  "transactionPassword": "Transaktions Passwort",
  "markDefaultAddress": "Als Standardlieferadresse markieren",
  "edit": "Bearbeitet von",
  "delete": "Löschen",
  "Opt": "Wählen",
  "piece": "Stck",
  "orderDetails": "Bestelldetails",
  "shopCollection": "Fügen Sie den Shop zu den Favoriten hinzu",
  "addAddress": "Neue Adresse hinzufügen",
  "signUp": "Anmeldung",
  "loginTips": "Sie haben bereits ein Konto?",
  "loginIn": "Anmeldung",
  "mobile": "Telefon-Nr",
  "modifyAddress": "Adresse bearbeiten",
  "desc": "Als Standardadresse festlegen",
  "keep": "Pflegen",
  "onlineService": "Online Dienste",
  "send": "Schicken",
  "EsShop": "Online-Shop",
  "desc3": "Geben Sie das Transaktionspasswort ein",
  "desc4": "Geben Sie Ihr Transaktionspasswort ein",
  "desc6": "Geben Sie Ihr Transaktionspasswort erneut ein",
  "setUpPayPaw": "Transaktionskennwort festlegen",
  "setSuccess": "Einrichtung erfolgreich",
  '购物车还没有商品': 'Der Einkaufswagen hat noch keine Waren',
  '去购物': 'Einkaufen gehen',
  "confirmPayPaw": "Bestätigen Sie das Transaktionspasswort",
  "paymentSuccessful": "Zahlung erfolgreich abgeschlossen",
  "desc5": "Falsche Lieferadresse? Kontakt",
  "customeService": "Online-Kundendienst",
  "BackHome": "Zurück zur Startseite",
  "Checkorder": "Bestellung ansehen",
  "ForgotPassword": "Passwort vergessen?",
  "signIn": "Anmeldung",
  "noAccount": "Keine Kontonummer?",
  "pleaseEnterAccount": "Bitte Kontonummer eingeben",
  "pleaseEnterPassword": "Bitte Passwort eingeben",
  "password": "Passwort",
  "mobilePhone": "Telefonnummer",
  "pleaseEnterPhoneNumer": "Bitte geben Sie die Telefonnummer ein",
  "setPassword": "Passwort festlegen",
  "noDataFound": "Keine Daten gefunden",
  "searchCountry": "Geben Sie den Ländernamen und die Ortsvorwahl ein, um zu suchen",
  "pleaseEnterEmail": "Bitte stellen Sie das Postfach ein",
  "invitationCode": "Einladungscode",
  "plaeseEnterInvitaionCode": "Bitte legen Sie den Einladungscode fest",
  "pleaseSetLoginPassword": "Bitte legen Sie das Login-Passwort fest",
  "selectDeliveryAddress": "Lieferadresse auswählen",
  "totalOf": "Gesamt",
  "items": "Artikel",
  "orderSummary": "Bestellübersicht",
  "paymentMethod": "Bezahlverfahren",
  "Balance": "Gleichgewicht",
  "payPal": "PayPal",
  "notOpen": "Diese Zahlungsmethode ist für Ihre Region noch nicht verfügbar",
  "mastercard": "MasterCard",
  "additional": "Extra",
  "handlingfee": "Servicegebühr erforderlich",
  "goodsNumber": "Menge der Produkte",
  "deliveryFee": "Fracht",
  "totalNum": "Gesamt",
  "new": "Neu",
  "oldPassword": "Altes Kennwort",
  "pleaseEnterOldPassword": "Bitte geben Sie das alte Passwort ein",
  "newPassword": "Neues Kennwort",
  "plaseeEnterNewPassword": "Bitte geben Sie das neue Passwort ein",
  "confirmPassword": "Bestätige das Passwort",
  "plaseeENterConfirmPassword": "Bitte geben Sie das Bestätigungspasswort ein",
  "twoPawword": "Zwei Passwörter sind nicht gleich",
  "rechargeAddress": "Adresse aufladen",
  "plaseEnterRechargeAddress": "Bitte geben Sie die Aufladeadresse ein",
  "userCenter": "Persönliches Zentrum",
  "merchantSettled": "Händlereintrag",
  "upNew": "Neues Produkt aufgeführt",
  "balanceNot": "Das Guthaben reicht nicht. Bitte aufladen.",
  "NoProductSelected": "Produkt noch nicht ausgewählt",
  "ShippingAddressNotSet": "Lieferadresse nicht festgelegt",
  "consigneeName": "Name des Empfängers",
  "email": "Email:",
  "areaCode": "Internationale Vorwahl",
  "phoneNumber": "Telefonnummer",
  "nation": "Land",
  "state": "Provinz/Staat/Staat",
  "city": "Stadt",
  "postCode": "Postleitzahl",
  "address": "Detaillierte Adresse",
  "addAddressOrModifyAddress": "Neue Adresse hinzufügen/Adresse ändern",
  "setAsTheDefaultAddress": "Als Standardadresse festlegen",
  "proceed": "Weitermachen",
  "btnSure": "Bestätigen",
  "pleaseInput": "Bitte eingeben",
  "allProduct": "Alle Produkte",
  "myCommodityCollection": "Lieblingsprodukte",
  "myFollowedShops": "Folgen Sie dem Laden",
  "mySold": "Verkauft",
  "myPageviews": "Umfang des Surfens",
  "myPraiseRate": "Rate guter Bewertungen",
  "myUnfollow": "Entfolgen",
  "inputNum": "Zahlen",
  "inpuEmailErro": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  "goodsShip": "Sendung",
  "goodsShipTips": "Die Produkte werden innerhalb von 24 Stunden nach der Bestellung versendet. Wenn für die folgende Bestellung eine Logistikkontrolle besteht, kann sich die Bestellung verzögern. Bitte beachten Sie die Logistikinformationen der Bestellung oder wenden Sie sich an den Kundenservice.",
  "goodsFreight": "Fracht",
  "goodsFreeShipping": "Kostenlos",
  "goodsFreightTips1": "1. Zusammensetzung der grenzüberschreitenden Produktfracht: Fracht = Versandgebühr + Fernfracht + Zustellgebühr",
  "goodsFreightTips2": "2. Bei Nichteinhaltung der Versandbedingungen wird die Fracht nach den tatsächlichen Bedingungen berechnet.",
  "goodsFreightTips3": "3. Das Recht der endgültigen Auslegung liegt bei der Plattform.",
  "pleaseValidPostCode": "Bitte geben Sie mehr als 4 Ziffern ein",
  "pleaseValidEmail": "Bitte geben Sie die korrekte E-Mail-Adresse ein",
  "pleaseValidPhone": "Bitte geben Sie die richtige Telefonnummer ein",
  "productAvailable": "Dieses Produkt wurde entfernt",
  "validatorMaxNumber": "Der Betrag überschreitet das Limit",
  "validatorRequire": "Erforderliche Elemente dürfen nicht null sein",
  "validatorPhone": "Bitte geben Sie die richtige Telefonnummer ein",
  "validatorEmail": "Bitte geben Sie das richtige E-Mail-Format ein",
  "validatorPassword": "Das Passwort besteht aus 6-12 Ziffern oder Buchstaben(enthält Sonderzeichen)",
  "validatorSixNumber": "Bitte geben Sie 6 reine Ziffern ein",
  "validatorFourMoreNumber": "Bitte geben Sie eine Kombination aus 4-32 Ziffern oder Buchstaben ein",
  "validatorIpRule": "Falsches IP-Format",
  "validatorChineseAndEnglish": "Nur Chinesisch und Englisch, Eingabebereich: 8–64 Zeichen",
  "collectionSuccess": "Zu Favoriten hinzufügen erfolgreich",
  "followedSuccess": "Folgen erfolgreich",
  "cancelSuccess": "Abbruch erfolgreich",
  "evaluateOrder": "Rückblick mit Bildern",
  "evaluateOrderPlaceholder": "Bitte überprüfen Sie die Produkte",
  "operationSuccess": "Vorgang erfolgreich",
  "confirmReceiveGoods": "Bestätigen Sie den Erhalt des Produkts oder nicht",
  "evaluateOrderSuccess": "Überprüfung erfolgreich",
  "yesterday": "Gestern",
  "notLogin": "Sie haben sich noch nicht eingeloggt.",
  "delAllHistoryRecord": "Möchten Sie wirklich alle Verlaufsdatensätze löschen?",
  "or": "Oder",
  "tipsRemindsText": "Der Händler erhält eine Mahnung, nachdem der Versand gemahnt wurde",
  "tipsRemindsCount": "Es kann nur einmal gemahnt werden.",
  "tipsRemindsMerchant": "Händler erinnern",
  "tipsRemindsSuccess": "Erinnerung erfolgreich",
  "noCartTips": "Deine Einkaufstasche ist leer. Beginn mit dem Einkauf.",
  "defaultRate": "Das System verwendet standardmäßig positive Bewertungen",
  "prevPage": "Vorherige Seite",
  "nextPage": "Nächste Seite",
  "returnApply": "Erstattungsantrag",
  "returnReason": "Grund der Rückerstattung",
  "returnAmount": "Rückgabebetrag",
  "returnRemark": "Rücksendeanleitung",
  order: {
    cancel: "Bestellung stornieren",
    payment: "Zahlen Sie jetzt",
    remind: "Erinnern Sie sich an den Versand",
    return: "Antrag auf Produktrückerstattung",
    evaluate: "Jetzt überprüfen",
    logistics: "Logistik ansehen",
    noRefund: "Nicht erstattet",
    refunding: "Rückerstattung läuft",
    refundSuccess: "Rückerstattung erfolgreich",
    refundFail: "Rückerstattung fehlgeschlagen",
    confirm: "Empfang bestätigen",
    expressCompany: 'Kurier',
    trackingNo: 'Sendungsnummer',
    noOrderShipping: 'Keine Versanddaten',
    noTransitSteps: 'Keine Sendungsverfolgung',
    logisticsLoadFail: 'Logistik konnte nicht geladen werden. Bitte später erneut versuchen.',
  },
  "remindTitle": "Erinnern Sie sich an den Versand",
  "remindContent": "Nachdem der Versand gemahnt wurde, erhält der Händler die Mahnung. Es kann nur einmal gemahnt werden.",
  "remindSuccess": "Erinnerung erfolgreich",
  "remindRepeat": "Diese Bestellung wurde erinnert.",
  "noComments": "Derzeit keine Bewertung",
  "storeSeach": "Produkt in diesem Shop suchen",
  "storeSeachTips1": "für dich gefunden",
  "storeSeachTips2": "Ähnliche Geschäfte gefunden",
  "storeSeachTips3": "Heim",
  "creditTit": "Kreditdienstleistungen",
  "getCoupons": "Holen Sie sich weitere Gutscheine",
  "yourEmail": "Ihre E-Mail-Adresse",
  "subscription": "Abonnements",
  "paymethods": "Bezahlverfahren",
  "footdec": "Die Benutzer der globalen Website von {name} kommen aus {num} Ländern auf der ganzen Welt und verwenden {coin} für die Abrechnung. {coin} ist eine grenzenlose Transaktion, die sofortige, kostengünstige Transaktionen auf der ganzen Welt ohne Wartezeiten und internationale Gebühren ermöglicht.",
  "custService": "Kundendienst",
  "helpLine": "Online-Kundendienst",
  "contactUs": "Kontaktiere uns",
  "partner": "Genossenschaftliche Lieferanten",
  "buyRules": "Käuferregeln",
  "sellerRules": "Richtlinie des Verkäufers",
  "returnsAndEx": "Rückgabe und Umtausch",
  "servicePolicy": "Servicepolitik",
  "returnPolicy": "Rücknahmegarantie",
  "user_Center": "Benutzerzentrum",
  "userReg": "Benutzer Registration",
  "orderTrack": "Bestellanfrage",
  "purchageHistory": "Kaufhistorie",
  "myPurse": "Mein Geldbeutel",
  "aboutUs": "Über uns",
  "Recruitment": "Warten Sie auf talentierte Personen",
  "news": "Nachrichteninformationen",
  "stateMent": "Erklärung zur modernen Sklaverei",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "ok",
  "metaMask": "MetaMask",
  "homeBannertips1": "Kaufmann werden",
  "homeBannertips2": "Gesamtprovision",
  "homeBannertips3": "max.",
  "homeBannerbtn": "Jetzt beitreten",
  "homeDownloadtips1": "Grenzüberschreitendes E-Commerce-Großhandelszentrum",
  "homeDownloadtips2": "Marken-Sonderangebot",
  "homeDownloadtips3": "Non-Stop-Rabatt",
  "homeDownloadtips4": "Android-Download",
  "homeDownloadtips5": "Apple-Download",
  "homeDownloadtips6": "Scannen Sie den QR-Code, um die APP herunterzuladen",
  "homeIconTips1": "100% echt",
  "homeIconTips2": "7 Tage Rückgaberecht",
  "homeIconTips3": "Frachtrabatt",
  "homeIconTips4": "Sichere Bezahlung",
  "headerSearchTips": "Bitte geben Sie ein Stichwort zur Suche ein",
  "collAccount": "Art der Ausleihe",
  "mine": "Mine.",
  "creditText1": "Startkredite lösen das Problem der Kreditaufnahme",
  "creditText2": "Erbringung von Dienstleistungen für Gründungsdarlehen und Kapitalumschlag",
  "creditWorry": "Kredit ohne Sorgen",
  "creditQuota": "Flexibles Limit",
  "creditQuotaINFO": "100.000 bis 30.000.000 mit flexiblem Limit und ohne Einschränkungen, mit einer maximalen Kreditlaufzeit von einem Jahr.",
  "quickLoan": "Schneller Kredit",
  "creditReview": "Bestehen Sie die Prüfung frühestens in einer Stunde, bei bestandener Prüfung wird der Kredit sofort freigegeben.",
  "safe": "Sicher und sorgenfrei",
  "safeInfo": "Keine Hypothek, keine Kaution, kein Rückruf, denn das ist eigentlich Privatsache.",
  "about": "Über uns",
  "aboutText1": "\"Wir engagieren uns für Kreditfinanzdienstleistungen, basierend auf der Geschäftsphilosophie \"\"Kunde zuerst\"\", und haben die Mission, das Problem des Kundenkapitalumsatzes zu lösen. Seit seiner Gründung hat das Unternehmen zahlreichen Kunden geholfen, das Problem des Kapitalumschlags zu lösen.\"",
  "aboutText2": "Limit: 100.000–30.000.000, flexible Rückzahlungsmethode mit niedrigen Zinsen, keine Vorabgebühr, Online-Darlehen, kein Telefonanruf zur Überprüfung, vertrauliche Informationen und Ausleihe am selben Tag.",
  "contactUs1": "Wenn Sie kein Geld von Ihren Levelkollegen leihen möchten, kontaktieren Sie uns bitte.",
  "committed": "Engagiert für Unternehmerdarlehensdienste",
  "financial": "Sprechen Sie Ihre finanziellen Bedenken an",
  "partnersTit": "Partner-Online-Ausleihplattform",
  "application": "Kreditantrag",
  "applicant": "Antragsteller",
  "actualName": "Echter Name",
  "yourName": "Bitte geben Sie den Namen ein",
  "term": "Laufzeit des Darlehens",
  "applicationAmount": "Angeforderter Betrag",
  "rates": "Darlehenszinssatz",
  "loanMethod": "Art der Ausleihe",
  "accountB": "Kontostand",
  "countryOf": "Staatsangehörigkeit",
  "myloan": "Mein Darlehen",
  "applyLoan": "Ein Darlehen beantragen",
  "loaned": "Ausgeliehen",
  "interest": "Aufgelaufene Zinsen",
  "esRepayment": "Geschätzte Rückzahlung",
  "loanHistory": "Kreditaufnahme",
  "applicantDate": "Antragsdatum",
  "repayment": "Rückzahlung",
  "cycle": "Rückzahlungszyklus",
  "fixedRate": "Fester Zinssatz",
  "successLoan": "Darlehen erfolgreich",
  "Reapply": "Bewerben Sie sich erneut",
  "borrow": "Kredit fehlgeschlagen",
  "applicantIn": "Bewerbung läuft",
  "repaid": "Rückzahlung",
  "overdue": "Überfällig",
  "estirepay": "Geschätzte Rückzahlung",
  "loanDays": "Anzahl der ausgeliehenen Tage",
  "reAmount": "Rückzahlungsbetrag",
  "repay": "Rückzahlungsmodus",
  "entRepay": "Rückzahlung bestätigen",
  "foryourmoney": "Wenn Sie knapp bei Kasse sind, nirgendwo Geld leihen können oder sich schämen, Geld von Ihren Freunden zu leihen, können Sie uns kontaktieren. Wir haben den gesamten Prozess des professionellen Service, um Ihre Zweifel jederzeit zu beantworten. Unser Ziel ist es, jeden Kredit transparent zu machen, damit Kunden ihn schnell und sicher nutzen können.",
  "onlineApplin": "Online bewerben",
  "businessloan": "Antrag auf Existenzgründungsdarlehen",
  "selectCountry": "Bitte wählen Sie eine Nationalität aus",
  "selectPeriod": "Bitte wählen Sie einen Zeitraum aus",
  "passPortImg": "ID-Nr./Pass-Nr.",
  "uploadId": "Foto-/Pass-Upload des Zertifikats",
  "readAndAgree": "Ich habe gelesen und stimme zu",
  "loanAgree": "Kreditvereinbarung",
  "submitApplica": "Antragstellung",
  "photoExample": "Beispiel zum Fotografieren",
  "discounted": "Reduzierte Produkte",
  "days": "Tag",
  "privacyPolicy": "Datenschutz-Bestimmungen",
  "delivery": "Lieferung und Abholung",
  "checkAgreement": "Bitte Zustimmung ankreuzen!",
  "businessPhone": "Geschäftstelefon",
  "businessEmail": "Firmen-E-Mail",
  recommendclass:"Kategorie empfehlen",
  "滑动验证":"Rollen Sie zur Bestätigung",
  "最多上传9张图片":"Hochladen von bis zu 9 Bildern",
  "账号注销":"Konto abmelden",
  "确定注销":"Abmelden bestätigen",
  "您的账号":"Ihr Konto",
  "为什么要离开":"Warum verlassen Sie uns?",
  "您还有余额,不能注销账号":"Sie haben noch einen Restbetrag, können Ihr Konto nicht abmelden!",
  "请输入注销理由":"Bitte geben Sie den Grund für die Abmeldung ein",
  "您确认要注销吗?":"Möchten Sie sich wirklich abmelden?",
  "我再考虑下": "Ich überlege noch einmal",
  "同意注销": "Zustimmen zur Abmeldung",
  "cancelInfo":"warnen! Bitte seien Sie vorsichtig, wenn Sie das Konto kündigen. Wenn Sie das Konto nicht mehr verwenden, können Sie auf [Der Kündigung zustimmen] klicken. Möglicherweise können Sie sich nicht innerhalb weniger Tage nach der Kündigung registrieren.",
  "注销成功":"Abmeldung erfolgreich",
  "App下载(买家端)": "App-Download (Käuferseite)",
  "App下载(卖家端)": "App-Download (Verkäuferseite)",
  "暂无店铺":"Kein Geschäft",
  "请选择":"Bitte wählen",
  "提款地址绑定":"Auszahlungsadresse binden",
  "绑定成功":"Bindung erfolgreich",
  "仅能绑定一个收款地址!":"Nur eine Empfangsadresse binden!",
  "最多包含10位小数":"Maximal 10 Dezimalstellen",
  "加密货币":"Kryptowährung",
  "银行卡":"Bankkarte",
  "企业电话":"Geschäftstelefon",
  "职业机会":"Berufschancen",
  '参数缺失': 'Fehlende Parameter',
  '充值数量必填': 'Aufladebetrag erforderlich',
  "充值币种":"Währung aufladen",
  "充值金额":"Aufladebetrag",
  "充值金额不得小于":"Aufladebetrag darf nicht kleiner sein als",
  "充值金额不得大于":"Aufladebetrag darf nicht größer sein als",
  "请先选择币种": "Bitte wählen Sie zuerst die Währung aus",
  "开户行":"Bank",
  "请输入开户行名称":"Bitte geben Sie den Namen der Bank ein",
  "银行卡号":"Kartennummer",
  "客户端下载": "Client-Download",
  "请输入银行卡号":"Bitte geben Sie die Kartennummer ein",
  "点击去支付":"Klicken Sie auf [Zur Zahlung]",
  "企业证明":"Unternehmensnachweis",
  当前余额:"Aktueller Kontostand",
  "提现方式":"Auszahlungsart",
  "备注":"Bemerkung",
  footTipTikTok:'BizSpring Mall ©️2024 Urheberrecht',
  TikTokFoot:"BizSpring Mall ist eine globale soziale Kurzvideoplattform, die BizSpring und Asiens größtes Großhandelsunternehmen Alibaba in Zusammenarbeit gegründet haben. Es handelt sich um eine globale E-Commerce-Plattform und verfügt weltweit über drei selbst betriebene Smart Warehouses in Toronto (Kanada), Los Angeles und Chiba (Japan). Zu den in der App angebotenen Produkten gehören beliebte Produkte aus Japan, Südkorea, China und anderen asiatischen Ländern. Derzeit liegt die Gesamtzahl bei über 50.000 und wächst weiterhin rasant."
,
  "getCouponSuccess": "Coupon erhalten",
  "liveRooms": "Live-Räume",
  "liveStreaming": "Live",
  "notStarted": "Nicht gestartet",
  "finished": "Beendet",
  "myPoints": "Meine Punkte",
  "searchGoods": "Produkte suchen",
  "points": "Punkte",
  "point": "Punkte",
  "stock": "Bestand",
  "spec": "Spezifikation",
  "exchangeNow": "Jetzt einlösen",
  "currentPoint": "Meine Punkte",
  "pointNotEnough": "Nicht genug Punkte"

,
    "contactInfo": "Contact Information",
    "consignee": "Full Name",
    "phone": "Phone",
    "enterName": "Enter full name",
    "enterPhone": "Enter phone number",
    "country": "Country",
    "province": "State/Province",
    "detailAddress": "Detail Address",
    "enterAddress": "Enter street address",
    "paymentInfo": "Payment Information",
    "cardNumber": "Card Number",
    "cardHolder": "Cardholder Name",
    "enterCardHolder": "Enter cardholder name",
    "expiryDate": "Expiry Date",
    "cardNumberRequired": "Card number is required",
    "cardHolderRequired": "Cardholder name is required",
    "expiryDateRequired": "Expiry date is required",
    "emailRegistered": "This email is already registered. You can login after checkout.",
    "nameRequired": "Name is required",
    "phoneRequired": "Phone is required",
    "countryRequired": "Country is required",
    "addressRequired": "Address is required",
    "cardExpired": "Card has expired",
    "registerFailed": "Registration failed",
    "accountExists": "Account already exists, please login to continue",
    "operationFailed": "Operation failed",
    "continueToCheckout": "Continue to Checkout",
    "emailRequired": "Email is required",
    "emailInvalid": "Invalid email format",
    "中文繁體": "繁體中文",
    "中文简体": "简体中文",
    "日本語": "日本語",
    "shoppingCart": "Shopping Cart",
    "selectAll": "Select All",
    "goodsName": "Product Name",
    "subtotal": "Subtotal",
    "action": "Action",
    "selected": "Selected",
    "total": "Total",
    "emptyCart": "Your shopping cart is empty",
    "allStores": "All Stores",
    "searchStore": "Search stores",
    "viewStore": "Visit Store",
    "streamEnded": "Stream Ended",
    "liveGoods": "Live Products",
    "announcements": "Announcements",
    "pointHistory": "Points History",
    "type": "Type",
    "remark": "Remark",
    "accountBind": "Account Binding",
    "mobileBind": "Mobile Binding",
    "notBound": "Not Bound",
    "change": "Change",
    "bind": "Bind",
    "emailBind": "Email Binding",
    "enterMobile": "Enter mobile number",
    "enterEmail": "Please enter email",
    "verifyCode": "Verification Code",
    "enterCode": "Enter verification code",
    "sendCode": "Send Code",
    "codeSent": "Code sent successfully",
    "bindSuccess": "Binding succeeded",
    "save": "Save",
    "saveSuccess": "Saved successfully",
    "balancePay": "Balance Pay",
    "wechatPay": "WeChat Pay",
    "alipay": "Alipay",
    "totalAmount": "Total Amount",
    "confirmPay": "Confirm Payment",
    "paySuccess": "Payment succeeded",
    "renew": "Renew",
    "vipPrivileges": "VIP Privileges",
    "growthValue": "Growth Value",
    "expiry": "Expiry",
    "pointLottery": "Points Lottery",
    "costPoints": "Cost Points",
    "startLottery": "Start Lottery",
    "congratulations": "Congratulations",
    "betterLuckNextTime": "Better luck next time",
    "noLottery": "No lottery available",
    "insufficientPoints": "Insufficient points",
    "pendingComment": "Pending Review",
    "commented": "Reviewed",
    "close": "Close",
    "loginFail": "Login failed",
    "paymentFailed": "Payment failed",
    "subscribe": "Subscribe",
    "confirmDelete": "Are you sure you want to delete?",
    "tips": "Tips",
    "deleteSuccess": "Deleted successfully",
    "KEY": "德语(de)",
    "addImageHint": "(Bitte Bilder hinzufügen)",
    "deleteNode": "Löschen",
    "topPos": "Oben {n}",
    "col": "Spalte {n}",
    "pos": "Position {n}",
    "decoType_container": "Container",
    "decoType_title": "Titeltext",
    "decoType_richText": "Rich-Text",
    "decoType_notice": "Mitteilung",
    "decoType_blank": "Abstandhalter",
    "decoType_banner": "Karussell",
    "decoType_imageSingle": "Einzelbild",
    "decoType_imageMulti": "Mehrfachbild",
    "decoType_video": "Video",
    "decoType_goodsRecommend": "Produktempfehlung",
    "decoType_goodsSelection": "Produktauswahl",
    "decoType_seckill": "Flash-Sale",
    "decoType_groupBuy": "Gruppenkauf",
    "decoType_coupon": "Gutschein",
    "decoType_searchNav": "Suchnavigation",
    "decoType_search": "Suchfeld",
    "decoType_searchBox": "Suchfeld",
    "decoType_categoryNav": "Kategorie-Navigation",
    "decoType_goodsCategory": "Produktkategorie",
    "decoType_navIconRow": "Navigations-Icons",
    "decoType_imageScroll": "Bildlauf",
    "decoType_pageBanner": "Seitenbanner",
    "decoType_tabs": "Tabs",
    "decoType_brand": "Marke",
    "decoType_storeRecommend": "Shop-Empfehlung",
    "decoType_hotSelection": "Top-Auswahl",
    "decoType_footerLinkGroup": "Fußzeilen-Links",
    "decoType_partnerLogoRow": "Partner",
    "decoType_icpInfo": "ICP-Info",
    "decoType_topNavMenu": "Top-Navigation",
    "decoType_logoBlock": "Logo",
    "decoType_langSwitcher": "Sprache",
    "decoType_currencySwitcher": "Währung",
    "decoType_loginBlock": "Anmeldung",
    "decoType_cartIcon": "Warenkorb",
    "decoType_messageIcon": "Nachrichten",
    "seckillPrice": "Flash-Preis",
    "seckillTag": "Flash-Sale",
    "seckillCountdown": "Endet in",
    "seckillNotStarted": "Demnächst",
    "seckillRushing": "Läuft jetzt",
    "seckillWillStart": "Demnächst",
    "seckillBuy": "Jetzt kaufen (Flash)",
    "groupPrice": "Gruppenpreis",
    "groupRequiredNum": "Personen für Gruppe",
    "noGroupBuy": "Einzeln kaufen",
    "groupRule1": "1. Artikel wählen",
    "groupRule2": "2. Gruppe starten",
    "groupRule3": "3. Gruppe komplett → Versand",
    "marketingMoneyOff": "Rabatt",
    "marketingFreeShipping": "Gratisversand",
    "marketingGift": "Geschenk",
    "marketingCoupon": "Gutschein",
    "marketingGroup": "Gruppenkauf",
    "marketingSeckill": "Flash-Sale",
    "marketingExpired": "Aktion abgelaufen",
    "marketingNotActive": "Aktion nicht aktiv",
    "alreadyGotCoupon": "Erhalten",
    "couponReceived": "Erhalten",
    "hotSearch": "Beliebte Suche:"
}